var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"flex items-center flex-no-shrink text-white mr-6 no-underline",attrs:{"href":"/"}},[_c('img',{staticClass:"block h-24 mr-4",attrs:{"src":require("./../assets/lingua-ai-logo.png"),"alt":"Lingua AI: Учим языки легко"}}),_c('span',{staticClass:"font-bold text-3xl font-sans"},[_vm._v("Lingua AI")])])
}]

export { render, staticRenderFns }